import { address as mainAddress, abi as mainAbi } from '../contract/pro/main'
import { address as customAddress, abi as customAbi } from '../contract/pro/custom'
import { address as miningAddress, abi as miningAbi, abiMap } from '../contract/pro/mining'
import { address as mappingAddress, abi as mappingAbi } from '../contract/pro/mapping'
import { network } from '../network/pro'
export default {
  env: 'pro',
  baseUrl: 'https://api.miratoken.vip',
  gameApiBaseUrl: 'https://api.miratoken.vip', // 游戏API的baseUrl (带端口)
  isEnableEncryption: true,
  isLog: false,
  isEnableConsole: false, //生产环境禁用console.log输出
  isVerifyToken: true,
  suffix: '4cf4c22f6e6ce089937de71339f1b87d',
  main: {
    address: mainAddress,
    abi: mainAbi
  },
  custom: {
    address: customAddress,
    abi: customAbi
  },
  // 挖矿合约
  mining: {
    address: miningAddress,
    abi: miningAbi,
    abiMap
  },
  // 兑换配置 - BNB转账
  exchange: {
    bnbAddress: '0xbB41eCa8A5fe9205ab3B036565656B06d67cdDf1',
    bnbAmount: '0.00035' // BNB数量
  },
  // 映射合约
  mapping: {
    address: mappingAddress,
    abi: mappingAbi
  },
  // LON合约地址
  lonContract: {
    address: '0x9145c751eb56354FD24C7f7215bCCF8e40cD4C2d',
    decimal: 18
  },
  network
}
